import i18n from 'i18n'
import React from 'react'
import type { TFunction } from 'i18next'
import { commonMenuList } from 'apptype-config'
import { ADMIN_CONSOLE_HOME, featureFlags } from 'config/feature-flags'
import AdminIcon from '@/assets/images/menu/icon-settings-menu.svg'

export interface MenuItem {
  divider?: boolean
  title?: string
  key?: string
  url?: string
  icon?: string | React.ComponentType
  children?: MenuItem[]
  disabled?: boolean
  count?: number
  roles?: string[]
  target?: string
  category?: boolean
}

export interface MenuListResult {
  adminMenuList: MenuItem[]
  menuList: MenuItem[]
}

export default function getMenuList(): MenuListResult {
  const t = (i18n as any).t as TFunction
  const adminMenuList: MenuItem[] = [
    featureFlags.adminDashboard && {
      title: t('menu.admin.dashboard'),
      key: 'ConsoleDashboard',
      url: '/admin/dashboard',
    },
    {
      title: t('menu.admin.users'),
      key: 'ConsoleUsers',
      url: '/admin/users?active=true',
    },
    {
      title: t('menu.admin.groups'),
      key: 'ConsoleGroups',
      url: '/admin/groups',
    },
    {
      title: t('template.title.name'),
      key: 'ConsoleTemplates',
      url: '/admin/templates',
    },
    {
      title: t('menu.admin.activity'),
      key: 'ConsoleActivity',
      url: '/admin/activity',
    },
    featureFlags.adminSecurity && {
      title: t('menu.admin.security'),
      key: 'ConsoleSecurity',
      url: '/admin/security',
    },
  ].filter(Boolean) as MenuItem[]

  const adminConsoleMenuList: MenuItem[] = [
    {
      divider: true,
    },
    {
      title: t('menu.adminConsole'),
      key: 'adminConsole',
      url: ADMIN_CONSOLE_HOME,
      icon: AdminIcon,
    },
  ]

  const menuList = commonMenuList(i18n, adminConsoleMenuList)

  return {
    adminMenuList,
    menuList,
  }
}
